import { render, staticRenderFns } from "./PostListPage.vue?vue&type=template&id=e2f9eed6&scoped=true&"
import script from "./PostListPage.vue?vue&type=script&lang=js&"
export * from "./PostListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9eed6",
  null
  
)

export default component.exports